"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterstitialAction = exports.InterstitialName = void 0;
var InterstitialName;
(function (InterstitialName) {
    InterstitialName["SIMPLE_INTEREST_CONVERSION_INTERSTITIAL"] = "simple_interest_conversion_interstitial";
    InterstitialName["PRIME_V3_POST_ACTIVATION"] = "prime_v3_post_activation";
    InterstitialName["ENGAGEMENT_SIP_OFFER_POST_ACTIVATION"] = "engagement_sip_offer_post_activation";
    InterstitialName["SETUP_AUTOPAY"] = "setup_autopay";
})(InterstitialName || (exports.InterstitialName = InterstitialName = {}));
var InterstitialAction;
(function (InterstitialAction) {
    InterstitialAction["SKIPPED"] = "skipped";
})(InterstitialAction || (exports.InterstitialAction = InterstitialAction = {}));
